let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("beiob")).then(() => parcelRequire('jVWdZ'));